(function () {
  /** @type {any} */
  const win = window;

  /** @param {HTMLButtonElement} button */
  function getVariantId(button) {
    const card = button.closest('.kg-product-card');
    const select = card ? /** @type {HTMLSelectElement | null} */ (card.querySelector('.kg-product-select')) : null;
    return (select && select.value) || button.dataset.variantId;
  }
  
  function getCartSectionIds() {
    /** @type {string[]} */
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  /** @param {string} variantId */
  async function addToCart(variantId) {
    const sections = getCartSectionIds();
    const response = await fetch('/cart/add.js?sections=cart-icon', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to add item to cart');
    }

    const data = await response.json();

    window.SLIDECART_UPDATE(data);
    window.SLIDECART_SET_CART(data);
    /* Update Cart Bubble */
    if (data.sections) {
        const parser = new DOMParser();

        Object.entries(data.sections).forEach(([key, html]) => {
        const doc = parser.parseFromString(html, 'text/html');

        const newBubble = doc.querySelector('.cart-bubble__text-count');
        const currentBubble = document.querySelector('.cart-bubble__text-count');

        if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
        }
        });
    }    
    // window.SLIDECART_OPEN();

    return data;
  }

  document.addEventListener('click', async function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('.kg-complete-look-atc-button');
    if (!button) return;
    const buttonEl = /** @type {HTMLButtonElement} */ (button);

    const variantId = getVariantId(buttonEl);
    if (!variantId) return;

    buttonEl.disabled = true;

    try {
      buttonEl.textContent = 'Adding..';
      await addToCart(variantId);
    } catch (error) {
        console.error('Complete look add-to-cart failed:', error);
    } finally {
      buttonEl.textContent = 'Add';
      buttonEl.disabled = false;
    }
  });
})();
